
export default {
    name: 'RaceRegistrationTableItem',
    props: {
        data: [Number, String],
        label: String
    },
    data() {
        return {
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/races/view-race/race-registration/table-item/table-item.js